import { SiFirebase } from 'react-icons/si'

export const FirebaseTech = () => {
    return (
        <div>
        <SiFirebase />
        <h4>Firebase</h4>
        </div>
    )
}